import React from 'react'
import { withIcon } from '../../withIcon'

function DocumentIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M7 3.625C6.24061 3.625 5.625 4.24061 5.625 5V19C5.625 19.7594 6.24061 20.375 7 20.375H17C17.7594 20.375 18.375 19.7594 18.375 19V5C18.375 4.24061 17.7594 3.625 17 3.625H7ZM4.375 5C4.375 3.55025 5.55025 2.375 7 2.375H17C18.4497 2.375 19.625 3.55025 19.625 5V19C19.625 20.4497 18.4497 21.625 17 21.625H7C5.55025 21.625 4.375 20.4497 4.375 19V5ZM8.375 7C8.375 6.65482 8.65482 6.375 9 6.375H15C15.3452 6.375 15.625 6.65482 15.625 7C15.625 7.34518 15.3452 7.625 15 7.625H9C8.65482 7.625 8.375 7.34518 8.375 7ZM8.375 11C8.375 10.6548 8.65482 10.375 9 10.375H15C15.3452 10.375 15.625 10.6548 15.625 11C15.625 11.3452 15.3452 11.625 15 11.625H9C8.65482 11.625 8.375 11.3452 8.375 11ZM8.375 15C8.375 14.6548 8.65482 14.375 9 14.375H13C13.3452 14.375 13.625 14.6548 13.625 15C13.625 15.3452 13.3452 15.625 13 15.625H9C8.65482 15.625 8.375 15.3452 8.375 15Z" fill={color}/>
    </svg>
  )
}

export default withIcon(DocumentIcon)
